"use client";
import type { ReactElement, ReactNode } from "react";
import { LuInfo } from "react-icons/lu";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils/lib";
interface InfoTooltipProps {
  text: ReactNode;
  iconSize?: number;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
  children?: ReactElement;
  nativeButton?: boolean;
  iconClassName?: string;
  iconColor?: string;
  disableHoverablePopup?: boolean;
  delay?: number;
  delayDuration?: number;
  mobile?: boolean;
}
export const InfoTooltip = ({
  children,
  text,
  iconSize = 20,
  iconColor = "text-muted hover:text-muted-foreground",
  side = "top",
  className = "",
  iconClassName = "",
  disableHoverablePopup,
  delay,
  delayDuration,
  nativeButton = false,
  mobile = true,
}: InfoTooltipProps) => {
  const iconStyle = children
    ? {}
    : {
        display: "inline-block",
        width: iconSize,
        height: iconSize,
      };
  const triggerButton = children ?? (
    <div>
      <LuInfo
        className={cn("cursor-pointer text-lg", iconClassName, iconColor)}
        size={iconSize}
      />
    </div>
  );
  return (
    <>
      {mobile && (
        <div
          className="
            contents
            md:hidden
          "
        >
          <Popover>
            <PopoverTrigger
              nativeButton={nativeButton}
              style={iconStyle}
              render={triggerButton}
            />
            <PopoverContent className={className}>{text}</PopoverContent>
          </Popover>
        </div>
      )}
      {!mobile && (
        <div
          className="
            contents
            md:hidden
          "
        >
          {triggerButton}
        </div>
      )}
      <div
        className="
          hidden
          md:contents
        "
      >
        <Tooltip disableHoverablePopup={disableHoverablePopup ?? true}>
          <TooltipTrigger
            style={iconStyle}
            render={triggerButton}
            delay={delay ?? delayDuration ?? 50}
            closeDelay={0}
          />
          <TooltipContent
            className={cn("h-auto max-w-[200px]", className)}
            side={side}
          >
            {text}
          </TooltipContent>
        </Tooltip>
      </div>
    </>
  );
};
